import { 
    REQUEST_KNOW_THE_HOST_SECTIONS_FETCH_EM,
    FETCH_KNOW_THE_HOST_SECTIONS_EM_SUCCESS,
    FETCH_KNOW_THE_HOST_SECTIONS_EM_FAILURE,
    CLEAR_FETCH_KNOW_THE_HOST_SECTIONS_EM_STATES
} from './knowTheHost.types';

let initialState = {
    reload: false,
    response : {},
    error : null,
    loading : false
}

const fetchKnowTheHostSectionsEmReducer = (state = initialState, action) => {

    switch(action.type) {
        case REQUEST_KNOW_THE_HOST_SECTIONS_FETCH_EM :
            return {
                ...state,
                loading: true,
                error: null
            }

        case FETCH_KNOW_THE_HOST_SECTIONS_EM_SUCCESS:
            return {
                ...state,
                loading : false,
                response : action.payload,
                reload: false
            }

        case FETCH_KNOW_THE_HOST_SECTIONS_EM_FAILURE:
            return {
                ...state,
                loading : false,
                error : action.payload,
                reload: false
            }
        
        case CLEAR_FETCH_KNOW_THE_HOST_SECTIONS_EM_STATES:
            return {
                ...state,
                loading : false,
                response : {},
                error : null,
                reload: false
            }

        default:
            return state;
    }
}

export default fetchKnowTheHostSectionsEmReducer